import { THEME_MODES } from '../theme';

const darkColors = {
  textPrimary: '#FFFFFF',
  textSecondary: '#ACACAC',
  textMuted: '#ACACAC',
  textCaption: '#FFFFFFCC',
  textSubtle: '#A9A9A9',
  menuBg: '#303030',
  dialogBg: '#232323',
  dialogBorder: '#494949',
  borderSubtle: '#494949',
  inputText: '#FFFFFF',
  inputBorder: '#ACACAC',
  inputFocus: '#B9FF66',
  inputLabel: '#FFFFFFCC',
  accent: '#B9FF66',
  accentHover: '#A8E85C',
  activeTextOnAccent: '#141414',
  popoverHover: '#494949',
  iconOnSurface: '#FFFFFF',
  checkboxChecked: '#B9FF66',
  backdrop: 'rgba(0, 0, 0, 0.6)',
  filterBorderClosed: '#ACACAC',
  filterBorderOpen: '#B9FF66',
  filterSelectedText: '#B9FF66',
  menuItemText: '#FFFFFF',
  navInactiveIcon: '#B9FF66',
  navInactiveText: '#FFFFFF',
  footerBg: '#141414',
  surfaceElevated: '#303030',
  surfaceSecondary: '#232323',
  logo: '#B9FF66',
  authLayoutBg: '#101216',
  authPanelBg: '#1B1D22',
  tabSwitch: {
    wrapperBg: 'linear-gradient(190deg, #B9FF66 0%, #5a6b3a 75%, #2a3320 100%)',
    containerBg: 'linear-gradient(to bottom, #3D4537, #3E4638), #3A4033',
    tabInactiveColor: '#FFFFFF',
    tabActiveColor: '#141414',
    tabActiveBg: '#B4FF48',
    tabActiveBorder: '#B4FF48',
    wrapperBoxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    wrapperBorder: 'none',
  },
  notificationRowBorder: '#494949',
  notificationRowHover: '#494949',
  primaryActionBg: '#000000',
  primaryActionText: '#B9FF66',
};

const lightColors = {
  textPrimary: '#141414',
  textSecondary: '#6E6E6E',
  textMuted: '#6E6E6E',
  textCaption: 'rgba(20, 20, 20, 0.7)',
  textSubtle: '#6E6E6E',
  menuBg: '#FFFFFF',
  dialogBg: '#FFFFFF',
  dialogBorder: '#ACACAC',
  borderSubtle: '#ACACAC',
  inputText: '#141414',
  inputBorder: '#ACACAC',
  inputFocus: '#141414',
  inputLabel: 'rgba(20, 20, 20, 0.7)',
  accent: '#9EDD53',
  accentHover: '#8BC94A',
  activeTextOnAccent: '#141414',
  popoverHover: 'rgba(0, 0, 0, 0.04)',
  iconOnSurface: '#141414',
  checkboxChecked: '#9EDD53',
  backdrop: 'rgba(0, 0, 0, 0.3)',
  filterBorderClosed: '#ACACAC',
  filterBorderOpen: '#9EDD53',
  filterSelectedText: '#5A8F24',
  menuItemText: '#141414',
  navInactiveIcon: '#5A8F24',
  navInactiveText: '#141414',
  footerBg: '#E6E6E6',
  surfaceElevated: '#FFFFFF',
  surfaceSecondary: '#F4F4F4',
  logo: '#141414',
  authLayoutBg: '#F5F7FA',
  authPanelBg: '#FFFFFF',
  tabSwitch: {
    wrapperBg: '#FFFFFF',
    containerBg: '#F5F7FA',
    tabInactiveColor: '#6E6E6E',
    tabActiveColor: '#141414',
    tabActiveBg: '#9EDD53',
    tabActiveBorder: '#9EDD53',
    wrapperBoxShadow: 'none',
    wrapperBorder: '1px solid #ACACAC',
  },
  notificationRowBorder: '#E0E0E0',
  notificationRowHover: 'rgba(0, 0, 0, 0.04)',
  primaryActionBg: '#141414',
  primaryActionText: '#9EDD53',
};

export const getThemeColors = (theme) =>
  theme.palette.mode === THEME_MODES.DARK ? darkColors : lightColors;

export const getFilterButtonBorder = (theme, open) => {
  const colors = getThemeColors(theme);
  const color = open ? colors.filterBorderOpen : colors.filterBorderClosed;
  return `1px solid ${color}`;
};
